<template>
  <div>
    <h1 class="header-style">
      Site Manager <br> Check-in
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-in.
    </p>
    <v-stepper
      v-if="orgSettings.questionnaire_verification"
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          step="3"
          color="#000"
        />
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      v-if="!orgSettings.questionnaire_verification"
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />

        <v-divider />
        <v-stepper-step
          step="2"
          color="#000"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <staff-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <staff-questions
        v-if="showQuestionsPage"
        @questions-answered="toThirdStep"
      />
      <review-staff-checkin
        v-if="showStaffCheckInPage"
        @checkin-completed="checkInCompleted"
      />
    </div>
  </div>
</template>
  <script>
  import StaffLocationVerification from '../dialogComponents/StaffDialogs/checkin/StaffLocationVerification.vue';
  import ReviewStaffCheckIn from '../dialogComponents/StaffDialogs/checkin/ReviewStaffCheckIn.vue';
  import StaffQandA from '../dialogComponents/StaffDialogs/checkin/StaffQandA.vue';

  export default {
    name: 'StaffCheckInPage',
    components: {
      'staff-location-verification': StaffLocationVerification,
      'staff-questions': StaffQandA,
      'review-staff-checkin': ReviewStaffCheckIn,
    },
    data () {
      return {
        userCheckOut: 1,
        showLocationVerificationPage: false,
        step1SuccessColor: '',
        step2SuccessColor: '',
        showStaffCheckInPage: false,
        showQuestionsPage: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      checkInMethodType () {
        return this.$store.getters['swiftuser/getCheckInMethodType'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    mounted () {
      this.loadOnMount();
      this.fetchOrgDetails();
      this.checkSettingsLocation();
    },
    methods: {
      checkSettingsLocation () {
        this.userCheckIn = 1;
        this.showLocationVerificationPage = true;
        this.showQuestionsPage = false;
        this.showStaffCheckInPage = false;
      },
      checkSettingsQuestionnaire () {
        if (!this.orgSettings.questionnaire_verification) {
          this.showQuestionsPage = false;
          this.showStaffCheckInPage = true;
          this.userCheckIn = 2;
        }
      },
      loadOnMount () {
        if (this.checkInMethodType === null || Object.keys(this.selectedOrganization).length === 0) {
          this.$router.push({ name: 'CheckIn' });
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.selectedOrganization);
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckOut = 2;
        this.showLocationVerificationPage = false;
        this.showStaffCheckInPage = false;
        this.showQuestionsPage = true;
        this.checkSettingsQuestionnaire();
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.userCheckOut = 3;
        this.showLocationVerificationPage = false;
        this.showQuestionsPage = false;
        this.showStaffCheckInPage = true;
      },
      checkInCompleted () {
        this.$router.push({ name: 'Checkin Success' });
      },
    },
  };
  </script>
  <style scoped>

  </style>
